mx.comp.mapIFrameComponent = Ext.extend(Ext.ux.IFrameComponent, {
    theMap: null,
    isReverseGeocodingOnClick: true,
    dontCenterAfterResize: false,
    onRender: function(ct, position) {
        mx.comp.mapIFrameComponent.superclass.onRender.call(this, ct, position);
        var thiz = this;
        Ext.apply(this.getIframeWindow(), {
            dontCenterAfterResize: this.dontCenterAfterResize,
            ourCallback: this.callback,
            onMapReadyCallback: function(aMap) {
                thiz.theMap = aMap;
                thiz.onMapReadyCallback(aMap);
            },
            mapFeedback: thiz.mapFeedback,
            isReverseGeocodingOnClick: this.isReverseGeocodingOnClick,
            geocodingCallback: this.geocodingCallback,
            addressFormatter: this.addressFormatter,
            MXBT: MXBT,
        });
    },
    callback: null,
    searchOnMap: Ext.emptyFn,
    getIframeWindow: function() {
        return Ext.isOpera ? this.el.dom : this.el.dom.contentWindow;
    },
});
Ext.reg('mapiframe', mx.comp.mapIFrameComponent);
